export const geofenceInitialState = {
  loading: false,
  bounds: {
    north: 13.173706,
    east: 77.8826809,
    south: 12.7342888,
    west: 77.3791981
  },
  drawingOpts: null,
  newCityName: "",
  currentCityName: "",
  availableCities: null,
  /*[
    // "Bangalore",
    // "Delhi",
    // "Chennai",
    // "Gurgaon",
    // "Hyderabad",
    // "Mumbai",
    // "Noida",
    // "Pune"
  ]*/ filter: {
    categoriesToShow: null, //
    searchQuery: null //
  },
  visibleLayers: ["geofence"],
  geofences: [],
  visibleGeofences: [],
  toPublishFence: null,
  showLoaderModal: 0,
  userAuthenticated: undefined,
  mapCenter: {
    lat: null,
    lng: null
  },
  orderpinsFilter: {
    last30Days: true,
    dateRange: null
  },
  orderpins: [],
  mapZoom: 10,
  replayActionOnAuthentication: [],
  additionalGeofences: {}
};
